import _extends from 'babel-runtime/helpers/extends';

export default {
  name: 'projectInfoDialog.vue',

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    dialogAttrs: function dialogAttrs() {
      return _extends({
        title: this.$t('playTurbo.common.pushRecordDialog.table.info'),
        appendToBody: true,
        customClass: 'project-info-dialog'
      }, this.$attrs);
    },


    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },

  methods: {}
};